
import { useNavigate } from "react-router-dom";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/AuthContext";
import { useProfile } from "@/contexts/ProfileContext";
import { User2 } from "lucide-react";

export function ProfileButton() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { profile } = useProfile(); // Get profile from context

  if (!user) {
    return <Button variant="default" onClick={() => navigate("/login")} className="bg-secondary hover:bg-secondary-hover text-secondary-foreground transition-colors duration-200 flex items-center gap-2 rounded-sm">
        <Avatar className="h-6 w-6">
          <AvatarFallback>
            <User2 className="h-4 w-4" />
          </AvatarFallback>
        </Avatar>
        <span>Sign in / Create Account</span>
      </Button>;
  }

  const userInitial = profile?.full_name?.[0]?.toUpperCase() || user.email?.[0]?.toUpperCase() || '?';
  
  return <Button variant="ghost" className="text-muted-foreground hover:text-foreground hover:bg-accent transition-colors duration-200 flex items-center gap-2" onClick={() => navigate("/profile")}>
      <Avatar className="h-8 w-8">
        <AvatarImage src={profile?.avatar_url} />
        <AvatarFallback className="bg-secondary text-secondary-foreground">
          {userInitial}
        </AvatarFallback>
      </Avatar>
      <span className="hidden sm:inline">{profile?.full_name || user.email}</span>
    </Button>;
}
